import AddRoundedIcon from "@mui/icons-material/AddRounded";
import { Button, Grid, MenuItem, Stack, TextField } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useMemo, useState } from "react";
import { OssDataGridFrame } from "../common/OssDataGridFrame";
import { OssSectionPanel } from "../common/OssPanel";

export const OssCalendarDayManager = ({ calendars = [], rows = [], loading, onSave }) => {
  const defaultCalendarId = useMemo(() => calendars.find((item) => Number(item.is_default) === 1)?.calendar_id || calendars[0]?.calendar_id || "", [calendars]);
  const [form, setForm] = useState({
    calendarId: defaultCalendarId,
    calendarDate: "",
    isWorkingDay: 0,
    dayName: "",
    note: "",
  });
  const update = (key, value) => setForm((prev) => ({ ...prev, [key]: value }));

  return (
    <OssSectionPanel title="휴일/예외 근무일">
      <Stack spacing={1.5}>
        <Grid container spacing={1.25}>
          <Grid item xs={6} md={2}>
            <TextField select size="small" fullWidth label="달력" value={form.calendarId || defaultCalendarId} onChange={(e) => update("calendarId", e.target.value)}>
              {calendars.map((calendar) => (
                <MenuItem key={calendar.calendar_id} value={calendar.calendar_id}>
                  {calendar.calendar_name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={6} md={2}>
            <TextField size="small" type="date" fullWidth label="날짜" InputLabelProps={{ shrink: true }} value={form.calendarDate} onChange={(e) => update("calendarDate", e.target.value)} />
          </Grid>
          <Grid item xs={6} md={2}>
            <TextField select size="small" fullWidth label="구분" value={form.isWorkingDay} onChange={(e) => update("isWorkingDay", e.target.value)}>
              <MenuItem value={0}>휴무일</MenuItem>
              <MenuItem value={1}>예외 근무일</MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={6} md={2.5}>
            <TextField size="small" fullWidth label="명칭" value={form.dayName} onChange={(e) => update("dayName", e.target.value)} />
          </Grid>
          <Grid item xs={12} md={2.3}>
            <TextField size="small" fullWidth label="비고" value={form.note} onChange={(e) => update("note", e.target.value)} />
          </Grid>
          <Grid item xs={12} md={1.2}>
            <Button fullWidth variant="contained" startIcon={<AddRoundedIcon />} disabled={loading} onClick={() => onSave({ ...form, calendarId: form.calendarId || defaultCalendarId })} sx={{ height: 40 }}>
              저장
            </Button>
          </Grid>
        </Grid>
        <OssDataGridFrame height={320}>
          <DataGrid
            disableRowSelectionOnClick
            rows={Array.isArray(rows) ? rows : []}
            getRowId={(row) => row?.calendar_day_id || row?.calendar_date || `${row?.calendar_id || "calendar"}-${row?.day_name || "day"}`}
            columns={[
              { field: "calendar_date", headerName: "날짜", flex: 0.9 },
              { field: "calendar_name", headerName: "달력", flex: 1 },
              {
                field: "is_working_day",
                headerName: "구분",
                flex: 0.8,
                valueGetter: (value, row) => (Number(row?.is_working_day ?? value) === 1 ? "예외 근무일" : "휴무일"),
              },
              { field: "day_name", headerName: "명칭", flex: 1 },
              { field: "note", headerName: "비고", flex: 1.3 },
            ]}
            loading={loading}
            hideFooter={(Array.isArray(rows) ? rows.length : 0) <= 10}
          />
        </OssDataGridFrame>
      </Stack>
    </OssSectionPanel>
  );
};
